import { useIsWorkspaceAgentPanelAvailable } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useIsWorkspaceAgentPanelAvailable';
import {
  isWorkspaceAgentPanelSlotOpen,
  useWorkspaceAgentPanelStore,
} from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { useURLClipIdSelector } from '~/hooks/useURLClipIdSelector';

/**
 * Whether the panel is sharing the screen with the asset view. The panel positions itself against
 * the viewport from this and the asset modal reserves a matching gutter from it, and the two live
 * in sibling subtrees, so the predicate has to be one shared reading or they drift apart.
 *
 * The stand-down rules themselves live in `useIsWorkspaceAgentPanelAvailable`, which the asset
 * header Tasks button reads too, so the inset never reserves space for a panel that is not there.
 */
export const useIsWorkspaceAgentPanelOverAssetView = () => {
  const { isWorkspaceAgentPanelAvailable } = useIsWorkspaceAgentPanelAvailable();
  // `getClipIdFromPath` returns `string | undefined`, so this is a truthiness check rather than a
  // comparison against `null`.
  const assetViewOpen = Boolean(useURLClipIdSelector());
  const dock = useWorkspaceAgentPanelStore((state) => state.dock);

  return {
    assetViewOpen,
    isWorkspaceAgentPanelOverAssetView:
      isWorkspaceAgentPanelAvailable && assetViewOpen && isWorkspaceAgentPanelSlotOpen({ dock }),
  };
};
